import { render, staticRenderFns } from "./CompInfo.vue?vue&type=template&id=7dac18a6&scoped=true&"
import script from "./CompInfo.vue?vue&type=script&lang=js&"
export * from "./CompInfo.vue?vue&type=script&lang=js&"
import style0 from "./CompInfo.vue?vue&type=style&index=0&id=7dac18a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dac18a6",
  null
  
)

export default component.exports